export default __webpack_public_path__ + "static/media/ESME_Logo.72209e87.png";